// Free-floating sticky note on the canvas. Three colors (yellow / rose / green),
// each rotated subtly per kind to keep the look hand-placed.

const KIND_BG = {
  yellow: 'bg-sticky-yellow',
  rose:   'bg-sticky-rose',
  green:  'bg-sticky-green',
};

const KIND_ROTATE = {
  rose:   'rotate(-1.5deg)',
  yellow: 'rotate(1deg)',
  green:  'rotate(-0.5deg)',
};

export function Sticky({ note }) {
  const bg = KIND_BG[note.kind] || 'bg-sticky-yellow';
  return (
    <div
      className={`sticky absolute border border-ink p-2.5 px-3 max-w-[180px] font-sans text-[12px] leading-snug ${bg}`}
      style={{
        left: note.pos_x,
        top: note.pos_y,
        transform: KIND_ROTATE[note.kind] || 'none',
      }}
    >
      {note.label && (
        <div className="font-mono text-[9px] uppercase tracking-[0.1em] text-ink-3 mb-1">
          {note.label}
        </div>
      )}
      <div className="text-ink-2">{note.body}</div>
    </div>
  );
}

export default Sticky;
